import React, { TextareaHTMLAttributes } from "react";

import Icon from "../Icon";
import Tooltip from "../Tooltip";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  register?: any;
}

const Textarea = ({ error, register, ...props }: TextareaProps) => {
  return (
    <div className="relative w-full">
      <textarea
        className="w-full p-4 border border-gray-200 focus:outline-none"
        ref={register}
        {...props}
      />
      {error ? (
        <div className="absolute left-0 z-10 flex justify-center">
          <Tooltip theme="danger">
            <Icon icon={faTimes}></Icon> {error}
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
};

export default Textarea;
